import {PersonEntity, PersonSelectorProps, personType} from "@ots-frontend/ots-data";
import {PersonSelect, PersonSelectProps} from "./PersonSelect";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {Box, Button, Modal, ModalProps} from "@mantine/core";

export type DriverSelectProps = Omit<PersonSelectProps, "selector"> & {
  selector?: Omit<PersonSelectorProps, "personType">
}

export const DriverSelect = (props: DriverSelectProps) => {
  const {selector, ...rest} = props;
  return (
    <PersonSelect {...rest} selector={{
      personType: personType.driver,
      ...selector
    }}/>
  );
};

export interface DriverSelectModalProps extends Omit<ModalProps, "onSubmit"> {
  select?: DriverSelectProps,
  onSubmit?: (persons: PersonEntity[] | undefined) => void
}

export const DriverSelectModal = (props: DriverSelectModalProps) => {
  const {
    select,
    onSubmit,
    ...rest
  } = props;

  const [selectedDrivers, setSelectedDrivers] = useState<PersonEntity[]>([])

  const {t} = useTranslation(["common"]);

  return (
    <Modal {...rest}>
      <Box>
        <DriverSelect
          {...select}
          onEntityChange={e => setSelectedDrivers(e)}/>
        <Button type="submit" mt="xl" onClick={(e) => {
          if (onSubmit) {
            onSubmit(selectedDrivers);
          }
        }}>
          {t("common.action.submit")}
        </Button>
      </Box>
    </Modal>
  );
};
